function showNewPasswordDialogOnValidationError({ state }) {
  let formSection = state.get('client.forms.validation.section')

  if(formSection === 'newPassword'){
    state.set('app.showNewPasswordDialog', true )
  }
}

export default showNewPasswordDialogOnValidationError



// WEBPACK FOOTER //
// ./src/modules/user/actions/showNewPasswordDialogOnValidationError.js